import React, { Component } from 'react';

interface IProps {
    gtmEvent(): void;
    name: string;
}

export class TerminatorInsurance extends Component<IProps, any> {

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'><span className='doddltext'>Thanks, {this.props.name}</span></h1>
                <div className='wrapper'>
                    <div className='row'>
                    <h2 className='l'>Your life quotes are now being sent to the email<br/>you have provided and will be with you<br/>in 5 minutes.</h2>
                    </div>
                    <div className='row'>
                        <p className='s'>You will receive your quotes shortly by email and one of our<br />life cover specialists will contact you to work through all options with you</p>
                    </div>
                    <div className='row pt-2'>
                        <div className='btn-primary' onClick={() => window.location.href='/'}>Close</div>
                    </div>
                </div>
            </header>
        );
    }
}
